export default "__VITE_ASSET__DamAUQc5__"